// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactModal__Content {
  width: 500px;
  height: 500px;
  top: 50% !important;
  left: 50% !important;
  right: auto !important;
  bottom: auto !important;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.75);
  border: 0 !important;
  color: white;
}
.ReactModal__Content--after-open {
  background: #2b2a29 !important;
  border-radius: 10px !important;
}
.ReactModal__Content::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #2b2a29;
  border-radius: 5px;
}
.ReactModal__Content::-webkit-scrollbar-thumb {
  background-color: #898989;
  border-radius: 5px;
}

.modal {
  display: flex;
  flex-direction: column;
}
.modal input {
  background-color: transparent;
  border: 1px solid #898989;
  outline: none;
  border-radius: 5px;
  height: 45px;
  color: #898989;
  padding-left: 10px;
  font-size: 16px;
  font-weight: 500;
}
.modal img {
  border-radius: 10px;
  margin-bottom: 15px;
}
.modal-products {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}
.modal-products-item {
  display: flex;
  align-items: center;
  margin-top: 10px;
  cursor: pointer;
}
.modal-products-item img {
  width: 70px;
  height: 70px;
  border-radius: 5px;
}
.modal-products-item span {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
}
.modal-products-item:hover span {
  color: #6E00FF;
}
.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #fefefe;
  margin-bottom: 16px;
}
.modal-descr {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #898989;
}
.modal span {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #fefefe;
}
.modal a {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #898989;
}

@media (max-width: 576px) {
  .ReactModal__Content {
    width: 350px;
    height: 400px;
  }
  .modal input {
    height: 35px;
    font-size: 12px;
  }
  .modal-products-item img {
    width: 60px;
    height: 60px;
  }
  .modal-products-item span {
    font-size: 12px;
  }
  .modal-title {
    font-size: 22px;
  }
  .modal-descr {
    font-size: 12px;
  }
  .modal span {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/style.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gCAAA;EACA,qCAAA;EACA,oBAAA;EACA,YAAA;AACF;AAAE;EACE,8BAAA;EACA,8BAAA;AAEJ;AAAE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAEJ;AAAE;EACE,yBAAA;EACA,kBAAA;AAEJ;;AAGA;EACE,aAAA;EACA,sBAAA;AAAF;AACE;EACE,6BAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AACJ;AACE;EACE,mBAAA;EACA,mBAAA;AACJ;AACE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAER;AADQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAGZ;AADQ;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;AAGZ;AAAY;EACI,cAAA;AAEhB;AAGE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AADJ;AAGE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAGE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAGE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;;AAKA;EACE;IACE,YAAA;IACA,aAAA;EAFF;EAKE;IACE,YAAA;IACA,eAAA;EAHJ;EAOM;IACE,WAAA;IACA,YAAA;EALR;EAOM;IACE,eAAA;EALR;EASE;IACE,eAAA;EAPJ;EASE;IACE,eAAA;EAPJ;EASE;IACE,eAAA;EAPJ;AACF","sourcesContent":[".ReactModal__Content {\n  width: 500px;\n  height: 500px;\n  top: 50% !important;\n  left: 50% !important;\n  right: auto !important;\n  bottom: auto !important;\n  transform: translate(-50%, -50%);\n  background-color: rgba(0, 0, 0, 0.75);\n  border: 0 !important;\n  color: white;\n  &--after-open {\n    background: #2b2a29 !important;\n    border-radius: 10px !important;\n  }\n  &::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n    background-color: #2b2a29;\n    border-radius: 5px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #898989;\n    border-radius: 5px;\n  }\n\n}\n\n.modal {\n  display: flex;\n  flex-direction: column;\n  & input {\n    background-color: transparent;\n    border: 1px solid #898989;\n    outline: none;\n    border-radius: 5px;\n    height: 45px;\n    color: #898989;\n    padding-left: 10px;\n    font-size: 16px;\n    font-weight: 500;\n  }\n  & img {\n    border-radius: 10px;\n    margin-bottom: 15px;\n  }\n  &-products {\n    display: flex;\n    flex-direction: column;\n    margin-top: 20px;\n    &-item {\n        display: flex;\n        align-items: center;\n        margin-top: 10px;\n        cursor: pointer;\n        & img {\n            width: 70px;\n            height: 70px;\n            border-radius: 5px;\n        }\n        & span {\n            margin-left: 10px;\n            font-size: 14px;\n            font-weight: 500;\n        }\n        &:hover {\n            & span {\n                color: #6E00FF;\n            }\n        }\n    }\n  }\n  &-title {\n    font-size: 24px;\n    font-weight: 700;\n    color: #fefefe;\n    margin-bottom: 16px;\n  }\n  &-descr {\n    margin-top: 10px;\n    font-size: 16px;\n    font-weight: 500;\n    color: #898989;\n  }\n  & span {\n    margin-top: 10px;\n    font-size: 14px;\n    font-weight: 400;\n    color: #fefefe;\n  }\n  & a {\n    margin-top: 10px;\n    font-size: 16px;\n    font-weight: 500;\n    color: #898989;\n  }\n}\n\n@media (max-width: 576px) {\n  .ReactModal__Content {\n    width: 350px;\n    height: 400px;\n  }\n  .modal {\n    & input {\n      height: 35px;\n      font-size: 12px;\n    }\n    &-products {\n      &-item {\n        & img {\n          width: 60px;\n          height: 60px;\n        }\n        & span {\n          font-size: 12px;\n        }\n      }\n    }\n    &-title {\n      font-size: 22px;\n    }\n    &-descr {\n      font-size: 12px;\n    }\n    & span {\n      font-size: 12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
